import constants from '../constants.js';




const ModifiedOn = {
  displayName: 'Modified on',
  dataAt: 'ModifiedOn',
  disabled: true,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const ModifiedBy = {
  displayName: 'Modified by',
  dataAt: 'ModifiedBy',
  disabled: true,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const CreatedOn = {
  displayName: 'Created on',
  dataAt: 'CreatedOn',
  disabled: true,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const CreatedBy = {
  displayName: 'Created by',
  dataAt: 'CreatedBy',
  disabled: true,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const UploadedBy = {
  displayName: 'Uploaded by',
  dataAt: 'UploadedBy',
  disabled: true,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const UploadedWhen = {
  displayName: 'Uploaded On',
  dataAt: 'UploadedWhen',
  disabled: true,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const IsDeleted = {
  displayName: 'Delete',
  dataAt: 'IsDeleted',
  disabled: false,
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const CompanyReferenceListId = {
  displayName: 'Id',
  dataAt: 'Id',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true,
};

const CompanyReferenceListDebtorIdentifier = {
  displayName: 'DebtorIdentifier',
  dataAt: 'DebtorIdentifier',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: false,
};
const CompanyReferenceListListId = {
  displayName: 'ListId',
  dataAt: 'ListId',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: false,
};
const CompanyReferenceListValue = {
  displayName: 'Value',
  dataAt: 'Value',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: false,
};
const CompanyReferenceListDescription = {
  displayName: 'Description',
  dataAt: 'Description',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: false,
};



const CompanyReferencesAddResource = {
  displayName: 'Company References',
  displayAs: constants.DISPLAY_AS.ADD_GRID_RESOURCE,
  dataAt: '',
  data:
  {
    DebtorIdentifier: '',
    ListId: '',
    Value: '',
    Description: ''
  },
  children: [CompanyReferenceListDebtorIdentifier,CompanyReferenceListListId,CompanyReferenceListValue,CompanyReferenceListDescription],
  showBack: false,// Show the Back button. This will hide the other buttons in lbaResource.
  endpoint: "CompanyReferences"
  
};

const CompanyReferencesResource = {
  displayName: 'Company References',
  iconClass: 'fa-plane',
  dataAt: '',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [IsDeleted,CompanyReferenceListDebtorIdentifier,CompanyReferenceListListId,CompanyReferenceListValue,CompanyReferenceListDescription,ModifiedOn,ModifiedBy,CreatedOn,CreatedBy],
  showBack: false,// Show the Back button. This will hide the other buttons in lbaResource.
  endpoint: "CompanyReferences",
  routeParamId: 'itemId',
  removeParamId: 'itemId',
  canDelete: false
};








const CompanyReferenceList = {
  rootNode: true,
  displayName: 'Company Reference (Top 1000)',
  iconClass: 'fa-plane',
  
  canAddNew: true,
  displayAs: constants.DISPLAY_AS.GRID,
  gridAdd: CompanyReferencesAddResource,
  gridItem: CompanyReferencesResource,
  gridCols: [{ name: 'DebtorIdentifier', key: 'DebtorIdentifier' },{ name: 'ListId', key: 'ListId' }, { name: 'Value', key: 'Value' }, { name: 'Description', key: 'Description' }],
  endpoint: 'CompanyReferences',
  ODataArgs: '?$filter=IsDeleted+eq+(false)&$top=1000'
  
};
const CompanyReferenceListFilter = {
  rootNode: true,
  displayName: 'Company Reference',
  iconClass: 'fa-plane',
  
  canAddNew: true,
  displayAs: constants.DISPLAY_AS.GRID,
  gridAdd: CompanyReferencesAddResource,
  gridItem: CompanyReferencesResource,
  gridCols: [{ name: 'DebtorIdentifier', key: 'DebtorIdentifier' },{ name: 'ListId', key: 'ListId' }, { name: 'Value', key: 'Value' }, { name: 'Description', key: 'Description' }],
  endpoint: "CompanyReferences",
  ODataArgs: "?$filter=IsDeleted+eq+(false)+and+DebtorIdentifier+eq+(':debtorId')+and+ListId+eq+(':listId')",
  
};


const CompanyReferenceManager = {
  rootNode: true,
  displayName: 'Company Reference Summary',
  iconClass: 'fa-pin',
  displayAs: constants.DISPLAY_AS.COMPANY_REFERENCE
};

export default {
  CompanyReferenceManager,
  CompanyReferencesResource,
  CompanyReferencesAddResource,
  ModifiedOn,
  CreatedOn,
  ModifiedBy,
  CreatedBy,
  UploadedBy,
  UploadedWhen,
  IsDeleted,
  CompanyReferenceList,
  CompanyReferenceListFilter,
  CompanyReferenceListDescription,
  CompanyReferenceListValue,
  CompanyReferenceListListId,
  CompanyReferenceListDebtorIdentifier,
  CompanyReferenceListId

}


// WEBPACK FOOTER //
// ./src/config/fields/companyReferenceList.js